module.exports = __webpack_public_path__ + "img/idiomas.1f677427.png";